import { render, staticRenderFns } from "./DataImg.vue?vue&type=template&id=f4af29d8"
import script from "./DataImg.vue?vue&type=script&lang=js"
export * from "./DataImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports